



































import AppModal from '@/components/AppModal.vue'
import AppButton from '@/components/AppButton.vue'
import AppTextField from '@/components/AppTextField.vue'
import { createComponent, computed, reactive } from '@vue/composition-api'
import { uploadImages, updateFactoryImages } from '../api'
import { useGA } from '../lib/useGA'

const mapFileListToArray = (fileList: FileList) => {
  const arr = []
  for (let i = 0; i < fileList.length; i++) {
    arr.push(fileList[i])
  }
  return arr
}

const mapFileUrl = (file: File) => {
  return URL.createObjectURL(file)
}

export default createComponent({
  name: 'FilterModal',
  components: {
    AppModal,
    AppButton,
    AppTextField
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    dismiss: {
      type: Function,
      required: true
    },
    images: {
      type: FileList
    },
    finishImagesUpload: {
      type: Function,
      required: true
    },
    finishUploaderForm: {
      type: Function,
      required: true
    },
    mode: {
      type: String,
      required: true,
      defaultValue: 'create'
    },
    factoryData: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const { event } = useGA()
    const formState = reactive({
      nickname: '',
      contact: '',
      uploading: false
    })

    const imageUrls = computed(() => {
      const urls = []
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      for (let i = 0; i < props.images!.length; i++) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        urls.push(URL.createObjectURL(props.images![i]))
      }

      return urls
    })

    return {
      formState,
      imageUrls,
      async handleImagesUpload () {
        formState.uploading = true

        if (props.mode === 'create') {
          try {
            event('uploadImages')
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const images = await uploadImages(props.images!)
            props.finishUploaderForm(formState.nickname, formState.contact)
            await props.finishImagesUpload(images, imageUrls)

            formState.uploading = false

            props.dismiss()
          } catch (err) {
            formState.uploading = false

            // TODO: show me some error
            console.error(err)
          }
        } else {
          event('updateFactoryImages')
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const images = await updateFactoryImages(props.factoryData.id, props.images!, {
            nickname: formState.nickname,
            contact: formState.contact
          })
          props.finishUploaderForm(formState.nickname, formState.contact)
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          await props.finishImagesUpload(images, mapFileListToArray(props.images!).map(mapFileUrl))

          formState.uploading = false
          props.dismiss()
        }
      },
      closeModal () {
        if (!formState.uploading) {
          props.finishImagesUpload([])
          props.finishUploaderForm('', '')
          props.dismiss()
        }
      }
    }
  }
})
